<div
    class="-translate-y-1/2 left-0 top-full absolute bg-sky-950 text-white p-0.5 opacity-0 pointer-events-none flex flex-col gap-2 sm:w-60 w-50 transition-all duration-300 ease-in z-50"
    [ngClass]="{
        'opacity-100 translate-y-0 pointer-events-auto!': app.menuActive,
    }"
    (click)="onMenuClick()"
>
    <ul>
        @for (item of model; track item; let i = $index) {
            <li
                class="overflow-hidden flex flex-col justify-center [&_ul]:ml-[5%] [&_a]:cursor-pointer [&_a]:hover:bg-cyan-700 [&_a]:bg-transparent [&_a]:transition-all [&_a]:duration-300 [&_a]:ease-in [&_a]:flex [&_a]:items-center [&_a]:gap-1 [&_a]:py-2 [&_a]:px-4 [&>a>*:last-child]:ml-auto [&.active-menuitem>a]:bg-cyan-700 [&.active-menuitem>a]:font-bold [&_a.active-menuitem-routerlink]:font-bold"
                app-menuitem
                [item]="item"
                [index]="i"
                [root]="true"
            ></li>
        }
    </ul>
</div>
